import { Injectable, inject } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { AsyncValidator, registerAsyncValidatorDecorator } from "@recursyve/ngx-form-generator";
import { Observable, of, timer } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ApiService } from "../../../../../../api/api.service";

export function RequestIdentifierIsUnique() {
    return registerAsyncValidatorDecorator({
        name: "RequestIdentifierIsUniqueValidator"
    });
}

@Injectable()
export class RequestIdentifierIsUniqueValidator extends AsyncValidator {
    private readonly apiService = inject(ApiService);

    public readonly name = "RequestIdentifierIsUniqueValidator";

    public validate(control: AbstractControl): Observable<ValidationErrors | null> {
        if (!control.value || control.value === "") {
            return of(null);
        }

        return timer(200).pipe(
            switchMap(() =>
                this.apiService.requests.identifierExists(control.value).pipe(
                    map((isNewRequestIdentifierValid) => {
                        if (!isNewRequestIdentifierValid) {
                            control.markAsTouched();
                            return { request_identifier_already_used: true };
                        }
                        return null;
                    })
                )
            )
        );
    }
}
